export const UISectionInsuranceRequests = "insurance-requests";
export const UISectionReceivedInsuranceRequests = "received-insurance-requests";
export const UISectionReports = "reports-section";
export const UISectionAgencies = "agencies";
export const UISectionFinancialRequests = "financial-requests";
export const UISectionFinancialRequestsV2 = "financial-requests-v2";
export const UISectionExpenses = "expenses";
export const UISectionBalanceRequests = "balance-requests";
export const UISectionInsuranceCompanies = "insurance-companies";
export const UISectionUsers = "users";
export const UISectionUserRoles = "user-roles";
export const UISectionUserLogs = "users-logs";
export const UISectionUsersViewAllUsersLoggedDevices =
  "users-view-all-users-logged-devices";
export const UISectionLeads = "leads";
export const UISectionInsurancePrices = "insurance-prices";
export const UISectionReportsAdvancedReport = "advanced-report";
export const UISectionResidenceAppointments = "residence-appointments";
export const UISectionAgencyLists = "agency-lists";
export const UISectionWhatsappDevices = "whatsapp-devices";
